import { Fleet } from "../models/cars.model";

function getWithDriverCars(): Array<Fleet> {
    return [
        {
            "Brand": "Hyundai",
            "Name": "Aura",
            "Charges": [3800],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kudal",
                "Sawantwadi",
                "Vengurla",
                "Devbag",
                "Devgad",
                "Kunkeshwar",
                "Malvan",
                "Tarkarli"
            ],
            "Hub": "Malvan, Maharashtra",
            "isSelfDrive": false,
            "KMIncluded": ["150"],
            "ExtraKMCharges": [15],
            "Image": "aura.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 5,
                "LuggageCapacity": 4,
                "Transmission": "Manual",
                "Avg/Ltr": "28"
            }
        },
        {
            "Brand": "Mahindra",
            "Name": "Xylo",
            "Charges": [4800],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kudal",
                "Sawantwadi",
                "Vengurla",
                "Devbag",
                "Devgad",
                "Kunkeshwar",
                "Malvan",
                "Tarkarli"
            ],
            "Hub": "Malvan, Maharashtra",
            "isSelfDrive": false,
            "KMIncluded": ["150"],
            "ExtraKMCharges": [18],
            "Image": "xylo.webp",
            "Details": {
                "Fuel": "Diesel",
                "SeatingCapacity": 7,
                "LuggageCapacity": 4,
                "Transmission": "Manual",
                "Avg/Ltr": "12"
            }
        },
        {
            "Brand": "Toyota",
            "Name": "Innova",
            "Charges": [4900],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kudal",
                "Sawantwadi",
                "Vengurla",
                "Devbag",
                "Devgad",
                "Kunkeshwar",
                "Malvan",
                "Tarkarli"
            ],
            "Hub": "Malvan, Maharashtra",
            "isSelfDrive": false,
            "KMIncluded": ["150"],
            "ExtraKMCharges": [18],
            "Image": "innova.webp",
            "Details": {
                "Fuel": "Diesel",
                "SeatingCapacity": 7,
                "LuggageCapacity": 4,
                "Transmission": "Manual",
                "Avg/Ltr": "12"
            }
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "Ertiga",
            "Charges": [4200],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kankavli",
                "Vaibhavwadi"
            ],
            "Hub": "Kankavli, Maharashtra",
            "isSelfDrive": false,
            "KMIncluded": ["150"],
            "ExtraKMCharges": [22],
            "Image": "ertiga_new.webp",
            "Details": {
                "Fuel": "Diesel",
                "SeatingCapacity": 6,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "15"
            }
        },
        {
            "Brand": "Toyota",
            "Name": "Innvova",
            "Charges": [4800],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kankavli",
                "Vaibhavwadi"
            ],
            "Hub": "Kankavli, Maharashtra",
            "isSelfDrive": false,
            "KMIncluded": ["150"],
            "ExtraKMCharges": [25],
            "Image": "innova.webp",
            "Details": {
                "Fuel": "Diesel",
                "SeatingCapacity": 7,
                "LuggageCapacity": 4,
                "Transmission": "Manual",
                "Avg/Ltr": "12"
            }
        },
        {
            "Brand": "Force",
            "Name": "Tempo Traveller (AC)",
            "Charges": [8500],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kankavli",
                "Vaibhavwadi"
            ],
            "Hub": "Kankavli, Maharashtra",
            "isSelfDrive": false,
            "KMIncluded": ["150"],
            "ExtraKMCharges": [38],
            "Image": "traveller-ac.webp",
            "Details": {
                "Fuel": "Diesel",
                "SeatingCapacity": 20,
                "LuggageCapacity": 6,
                "Transmission": "Manual",
                "Avg/Ltr": "7"
            }
        },
        {
            "Brand": "Force",
            "Name": "Tempo Traveller (Non-AC)",
            "Charges": [6500],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kankavli",
                "Vaibhavwadi"
            ],
            "Hub": "Kankavli, Maharashtra",
            "isSelfDrive": false,
            "KMIncluded": ["150"],
            "ExtraKMCharges": [28],
            "Image": "traveller.webp",
            "Details": {
                "Fuel": "Diesel",
                "SeatingCapacity": 20,
                "LuggageCapacity": 6,
                "Transmission": "Manual",
                "Avg/Ltr": "8"
            }
        },
        {
            "Brand": "Hyundai",
            "Name": "Aura",
            "Charges": [4500],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Navi Mumbai",
                "Mumbai",
                "Thane"
            ],
            "Hub": "Airoli, Navi Mumbai",
            "isSelfDrive": false,
            "KMIncluded": ["300"],
            "ExtraKMCharges": [15],
            "Image": "aura.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 4,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "--"
            }
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "Dzire",
            "Charges": [4500],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Navi Mumbai",
                "Mumbai",
                "Thane"
            ],
            "Hub": "Dombivali",
            "isSelfDrive": false,
            "KMIncluded": ["300"],
            "ExtraKMCharges": [15],
            "Image": "dzire.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 4,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "15"
            }
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "Ertiga",
            "Charges": [4800],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Navi Mumbai",
                "Mumbai",
                "Thane"
            ],
            "Hub": "Dombivali",
            "isSelfDrive": false,
            "KMIncluded": ["300"],
            "ExtraKMCharges": [17],
            "Image": "ertiga_new.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 6,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "15"
            }
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "XL6",
            "Charges": [4800],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Navi Mumbai",
                "Mumbai",
                "Thane"
            ],
            "Hub": "Mulund & Borivali",
            "isSelfDrive": false,
            "KMIncluded": ["300"],
            "ExtraKMCharges": [17],
            "Image": "xl6.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 5,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "15"
            }
        },
    ]
}
export default getWithDriverCars;